import { createOfflinePlayerId } from './buildLocalGuestPlayer';

function embedPlayer(playersById, playerId) {
  if (!playerId) return null;
  const player = playersById?.[playerId];
  if (!player) return { id: playerId };
  return {
    id: playerId,
    first_name: player.first_name || null,
    last_name: player.last_name || null,
    gender: player.gender || null,
    avatar_url: player.avatar_url || null,
    mixed_elo_rating: player.mixed_elo_rating ?? null,
    levels_elo_rating: player.levels_elo_rating ?? null,
  };
}

/**
 * Local scheduled game for Offline mode. Uses a client UUID so later seat/score
 * commands keep the same scheduled_games.id when the row is inserted on flush.
 */
export function buildLocalScheduledGame({
  id,
  sessionId,
  clubId,
  team1 = [],
  team2 = [],
  orderIndex = 0,
  createdBy = null,
  playersById = {},
} = {}) {
  const t1 = (team1 || []).filter(Boolean);
  const t2 = (team2 || []).filter(Boolean);
  const roster = [...t1, ...t2];
  const rosterComplete = (t1.length === 2 && t2.length === 2) || (t1.length === 1 && t2.length === 1);
  return {
    id: id || createOfflinePlayerId(),
    session_id: sessionId || null,
    club_id: clubId || null,
    team1_player1_id: t1[0] || null,
    team1_player2_id: t1[1] || null,
    team2_player1_id: t2[0] || null,
    team2_player2_id: t2[1] || null,
    roster_player_ids: roster,
    roster_size_expected: roster.length,
    roster_complete: rosterComplete,
    status: 'pending',
    order_index: orderIndex,
    created_at: new Date().toISOString(),
    created_by: createdBy,
    team1_player1: embedPlayer(playersById, t1[0]),
    team1_player2: embedPlayer(playersById, t1[1]),
    team2_player1: embedPlayer(playersById, t2[0]),
    team2_player2: embedPlayer(playersById, t2[1]),
  };
}
